import { cloneElement, ReactElement } from 'react';
import { BusinessStatus } from '../../mappers/business/toBusinessModel';
import { IconChecked } from '../icon/IconChecked';
import { IconDeclinedFilled } from '../icon/IconDeclinedFilled';
import { IconEyeOff } from '../icon/IconEyeOff';
import { IconHelp } from '../icon/IconHelp';
import { Flex, FlexProps } from '../layout/Flex';
import { Typography } from '../typography/Typography';

const badgesData = {
    published: {
        displayedName: 'Активен',
        styles: {
            backgroundColor: 'rgba(0, 179, 65, 0.1)',
            color: 'var(--color-success)',
        },
        leftIcon: <IconChecked size={12} />,
    },
    declined: {
        displayedName: 'Заблокирован',
        styles: {
            backgroundColor: 'var(--badge-danger-bg-color)',
            color: 'var(--color-danger)',
        },
        leftIcon: <IconDeclinedFilled size={12} />,
    },
    without_range: {
        displayedName: 'Скрыт из ленты',
        styles: {
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            color: '#FFFFFF',
        },
        leftIcon: <IconEyeOff size={12} />,
        rightIcon: <IconHelp size={12} />,
    },
};

interface BadgeData {
    displayedName: string;
    styles: {
        backgroundColor: string;
        color: string;
    };
    leftIcon: ReactElement;
    rightIcon?: ReactElement;
}

const getStatusBadgeData = (status: BusinessStatus): BadgeData => badgesData[status];

interface StatusBadgeProps extends FlexProps {
    businessStatus: BusinessStatus;
    statusDisplay?: string;
    onClick?: () => void;
}

export const StatusBadge = (props: StatusBadgeProps) => {
    const { businessStatus, statusDisplay, onClick, ...other } = props;
    const badgeData = getStatusBadgeData(businessStatus);

    return (
        <Flex
            direction="row"
            alignItems="center"
            {...badgeData.styles}
            px={0.5}
            py={0.25}
            borderRadius={0.75}
            width="fit-content"
            cursor="pointer"
            onClick={onClick}
            {...other}
        >
            <Flex spacing={0.5} direction="row" alignItems="center">
                <Flex spacing={0.25} direction="row" alignItems="center">
                    {badgeData.leftIcon
                        ? cloneElement(badgeData.leftIcon, { fill: badgeData.styles.color })
                        : null}
                    <Typography variant="caption" color={badgeData.styles?.color}>
                        {statusDisplay || badgeData.displayedName}
                    </Typography>
                </Flex>
                {badgeData.rightIcon
                    ? cloneElement(badgeData.rightIcon, { fill: badgeData.styles.color })
                    : null}
            </Flex>
        </Flex>
    );
};
